import React, { Component } from 'react'
import { Container } from 'components/Layout'
import CmsSection from '../../CmsSection'
import cn from 'classnames'
import s from './Tabs.scss'
import sLay from 'styles/modules/layout.scss'
import { Link } from 'react-router'
import { get } from 'lodash'

export default class Tabs extends Component {
  render() {
    const {
      tabTitles = [],
      tabs = [],
      pillLayout,
      location,
      queryParam,
      paddingTop,
      paddingBottom,
      appendToPageTitle,
    } = this.props
    const activeLabel = get(location, ['query', queryParam])
    const index = tabTitles.findIndex(item => item.id === activeLabel || item.label === activeLabel)
    const activeIndex = index === -1 ? 0 : index
    const selectedTab = tabs[activeIndex]

    return (
      <div className={cn(sLay['layout-column'], sLay['layout-align-center'])}>
        <Container>
          <div
            className={cn(sLay['layout-row'], pillLayout ? s.pillTabs : '')}
            style={{ marginTop: paddingTop, marginBottom: paddingBottom }}
          >
            {tabTitles.map((tab, idx) => (
              <Link
                key={idx}
                className={cn(
                  sLay.flex,
                  sLay['layout-column'],
                  sLay['layout-align-center-center'],
                  pillLayout ? s.pillTab : s.tab,
                  { [s.active]: activeIndex === idx }
                )}
                to={{
                  pathname: location.pathname,
                  query: {
                    ...location.query,
                    [queryParam]: tab.id || tab.label,
                  },
                }}
                // append tab's label to page title
                onClick={() => appendToPageTitle(tab.label)}
              >
                {tab.label}
              </Link>
            ))}
          </div>
        </Container>
        {selectedTab && (
          <CmsSection location={location} key={selectedTab.sys.id} section={selectedTab} />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/Tabs/Tabs.jsx